import React from 'react';
import { LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="w-full bg-navy border-t border-ivory/10" data-id="element-61" data-mp="3ggk72reij5xy">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-62" data-mp="32onkf2vm5o8y">
        <div className="text-center mb-12" data-id="element-63" data-mp="32m1awxp5wyo3">
          <p className="font-serif text-2xl md:text-3xl text-ivory" data-id="element-64" data-mp="36oo5359b2vog">
            Strategy. Partnerships. Communications. Growth.
          </p>
          <p className="mt-2 text-gold font-serif text-lg" data-id="element-65" data-mp="3ucxo5zf4x5bw">
            Igniting Growth Across Africa.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-8 border-t border-ivory/10" data-id="element-66" data-mp="3lem0a55nkln5">
          <Logo variant="light" data-id="element-67" data-mp="3qcnlavmn2v19" />

          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-ivory/70" data-id="element-68" data-mp="3qbvq3lwyezbi">
            <a href="#about" className="hover:text-ivory transition-colors" data-id="element-69" data-mp="2a19tpmiidoxa">About</a>
            <a href="#services" className="hover:text-ivory transition-colors" data-id="element-70" data-mp="2ezuubn1oaam9">Services</a>
            <a href="#why" className="hover:text-ivory transition-colors" data-id="element-71" data-mp="3labsrz9e6cry">Why Us</a>
            <a href="#approach" className="hover:text-ivory transition-colors" data-id="element-72" data-mp="3gbio8wc31w3x">Approach</a>
            <a href="#contact" className="hover:text-ivory transition-colors" data-id="element-73" data-mp="3v7zwheoz6um9">Contact</a>
          </nav>

          <div className="flex items-center gap-4" data-id="element-74" data-mp="3q7lo1vjgpinp">
            {[{
            Icon: LinkedinIcon,
            label: 'LinkedIn',
            href: '#'
          }, {
            Icon: TwitterIcon,
            label: 'Twitter',
            href: '#'
          }, {
            Icon: MailIcon,
            label: 'Email',
            href: 'mailto:hello@flickerafrica.com'
          }].map(({
            Icon,
            label,
            href
          }) => <a key={label} href={href} aria-label={label} className="flex items-center justify-center w-10 h-10 rounded-full border border-ivory/20 text-ivory/70 hover:border-gold hover:text-gold transition-colors" data-id="element-75" data-mp="huwhkupa1x58">
                <Icon size={18} data-id="element-76" data-mp="mptptzeqg2h2" />
              </a>)}
          </div>
        </div>

        <p className="mt-10 text-center text-xs text-ivory/40" data-id="element-77" data-mp="twxtbfc15kby">
          © {new Date().getFullYear()} Flicker Africa. A Pan-African growth
          consultancy. All rights reserved.
        </p>
      </div>
    </footer>;
}